// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_ff","advertDetailHeaderLocation__value":"c-m_fg"};